import { HttpClient } from '@opallabs/api'
import getIntegrationTask from '../getIntegrationTask'
import getWorkflow from '../getWorkflow'

const postIntegrationTask = ({
  taskId,
  workspaceIntegrationUuid,
  projectUuid,
}) =>
  HttpClient().post('/integrations/v1/tasks', {
    data: {
      attributes: {
        task_id: taskId,
        workspace_integration_uuid: workspaceIntegrationUuid,
        project_uuid: projectUuid,
      },
    },
  })

const createIntegrationTask = (params) => (dispatch, getState) =>
  postIntegrationTask(params)
    .then((response) => {
      if (params.shouldGetWorkflow === true) {
        dispatch(
          getWorkflow({
            type: 'content',
            identifier: params.contentId,
            showLoader: false,
            contentAccountId: getState().current_opal_id,
          })
        )
      }

      if (params.callback) {
        const integrationTaskId = response.data.data.id

        params.callback(() => {
          dispatch(getIntegrationTask(integrationTaskId))
        })
      }

      return {}
    })
    .catch((err) => {
      console.log(err)
      throw err
    })

export default createIntegrationTask
